
















import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeContratosStore from '@/components/RemuneracaoMedica/contratos/Store/BackofficeContratosStore'
import EventBus from '@/plugins/EventBus'
import { getSnackbarMessage } from '@/utils/common'
import { Gestor } from '@/types/_'

@Component
export default class ComponentModalAddGestores extends Vue {
  loadingBusca: boolean = false
  addGestoresLoading: boolean = false

  get getBackofficeContratosStore() {
    return getModule(BackofficeContratosStore, this.$store)
  }

  get addGestoresList() {
    return this.getBackofficeContratosStore.modal.addGestoresList
  }

  get gestores(): Gestor[] {
    return this.getBackofficeContratosStore.gestores
  }

  get selecionados(): Gestor[] {
    return this.getBackofficeContratosStore.selectedGestores
  }

  @Watch('addGestoresList')
  onToggleModal(isOpen: boolean) {
    if (isOpen) {
      this.getBackofficeContratosStore.clearGestores()
      this.getBackofficeContratosStore.clearSelectedGestores()
    }
  }

  subtitulo(gestor: Gestor): string {
    return `${formatCpf(gestor.documento)} · ${gestor.email || 'sem e-mail'}`
  }

  async onBusca(payload: { nome?: string, cpf?: string }) {
    this.loadingBusca = true

    const response = await this.getBackofficeContratosStore.getGestoresBySearch(payload)

    this.loadingBusca = false

    if (!response.success) {
      EventBus.$emit('setSnackbar', getSnackbarMessage(response.message || 'Ocorreu um erro ao buscar os gestores.', 'error'))
    }
  }

  onToggle(gestor: Gestor) {
    const jaSelecionado = this.selecionados.some((item: Gestor) => item.id === gestor.id)

    if (jaSelecionado) {
      this.getBackofficeContratosStore.setSelectedGestores(this.selecionados.filter((item: Gestor) => item.id !== gestor.id))
      return
    }

    this.getBackofficeContratosStore.setSelectedGestores([...this.selecionados, gestor])
  }

  async onConfirmar() {
    this.addGestoresLoading = true
    await this.getBackofficeContratosStore.addGestores()
    this.addGestoresLoading = false
    this.onClose()
  }

  onClose() {
    this.getBackofficeContratosStore.clearGestores()
    this.getBackofficeContratosStore.clearSelectedGestores()
    this.getBackofficeContratosStore.setShowModalAddGestoresList(false)
  }
}

function formatCpf(documento?: string | null): string {
  if (!documento) {
    return ''
  }

  if (documento.length !== 11) {
    return documento
  }

  return `${documento.substring(0, 3)}.${documento.substring(3, 6)}.${documento.substring(6, 9)}-${documento.substring(9, 11)}`
}
